import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, BreadCrumbData, ComponentConfig, getFields, getTargets, MenuTitleOptions, SelectedValue, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FACILITY_FORMS } from '../../../forms';

@Component({
  selector: 'ubs-overview-detail',
  templateUrl: './overview-detail.component.html',
  styleUrls: ['./overview-detail.component.scss']
})
export class OverviewDetailComponent extends BaseComponentConfig implements OnInit{
  @Input() facilityId:string;
  selectedValue:SelectedValue;
  breadCrumbs:BreadCrumbData[];

  options:ComponentConfig = {
    name: 'Facility Info',
    title: 'Facility Info',
    standAlone: true,
    defaultParameters: [],
    defaultAction: ActionState.EDIT,
    idFieldName: '',
    findForm: new OfbizForm,
    addForm: new OfbizForm({
      local: true,
      formName: "EditFacility",
      formLocation: "component://kwikstore/widget/FacilityForms.xml",
      fields: getFields("EditFacility", FACILITY_FORMS),
      targets: getTargets("EditFacility", FACILITY_FORMS),
      title: "facilityTypeId",
      idFieldName: "facilityId",
      appContext: "facility",
    }),
    addForms: [],
    listForms: [],
    actions: [],
    settings: [],
    summaryView: [],
    lookUpEndPoint: '',
    searchResults: undefined,
    breadCrumbData: {
      displayPrefix: "Product Feature Categories",
      label: "",
      level: 1,
      addFormText: "Create Feature Category",
      editFormText: "Update Feature Category"
    },
    childComponent: new ComponentConfig,
    customContainerItems: [],
    lookups: [],
    relations: [],
    selectedRelation: undefined,
    masterDetails: [],
    selectedMasterDetails: undefined,
    appContext: '',
    outGoingLinks: [],
    tasks: [],
    menuAndTitleOptions: undefined,
    getMenuAndTitleOptions: function (): MenuTitleOptions {
      throw new Error('Function not implemented.');
    },
    selectedTask: undefined
  }
  
  constructor(
    viewContainerService: ViewContainersService,
    menuService: NbMenuService,
    route: ActivatedRoute,
    router: Router,
    private componentStore: UbsComponentStoreService,
    updateComponentStoreService: UpdateComponentStoreService,
    configurationService:ConfigurationService,
  ) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
  }

  ngOnInit(): void {
    this.options.addForm.breadCrumbData = {
      selectedValue:{
        "event":"edit",
        "type":"EditFacility",
        "data":{
          formData:{
            formName:"EditFacility",
            formLocation:"component://kwikstore/widget/FacilityForms.xml",
          },
          "endPoint":"facilityy",
          "parameters":{"facilityId":this.facilityId}
        }
      }
    }
    this.componentConfig = new ComponentConfig(this.options);
  }
}
